import { AvatarComponent } from './avatar/avatar.component';

export {
	AvatarComponent,
};

export const Components = [
	AvatarComponent,
];
